import { render, staticRenderFns } from "./StandalonePreferences.vue?vue&type=template&id=7e46b468&scoped=true&"
import script from "./StandalonePreferences.vue?vue&type=script&lang=js&"
export * from "./StandalonePreferences.vue?vue&type=script&lang=js&"
import style0 from "./StandalonePreferences.vue?vue&type=style&index=0&id=7e46b468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e46b468",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VContainer,VFlex,VForm,VLayout,VProgressCircular,VSpacer,VSwitch})
